import { Customer } from "../models/customer";

const getOptionLabelCustomer = (customer?: Customer) => {
  if (customer?.fullName && customer?.email && customer?.phone) {
    return `${customer.fullName} - ${customer.email} - ${customer.phone}`;
  }
  if (customer?.fullName && customer?.email) {
    return `${customer.fullName} - ${customer.email}`;
  }

  if (customer?.name && customer?.email) {
    return `${customer.name}${customer.lastName ? ` ${customer.lastName}` : ""} - ${
      customer.email
    }`;
  }

  return "";
};

export default getOptionLabelCustomer;
